import { render } from "./breastFeeding.svg?vue&type=template&id=07304cba"
const script = {}
script.render = render

export default script